import { Injectable } from '@angular/core';

@Injectable()
export class CursoCategoria
{
  public categoria_id: number = 0;
  public nombre: string = '';
  public estado: boolean = true;

  constructor() 
  { 
  }

  limpiarVariables()
  {
    this.categoria_id = 0;
    this.nombre = '';
    this.estado = true;
  }
}
